export default __webpack_public_path__ + "static/media/774.c81994b4.png";